import {
  NEW_REPORT_FILE,
  NEW_REPORT_FILE_FAILED,
  NEW_REPORT_FILE_NOTIFIED,
  NEW_REPORT_FILE_RESET,
  NEW_REPORT_FILE_SUCCESS,
} from "../action/actionType";

const initialState = {
  loading: false,
  data: null,
  error: null,
  notified: false,
};

const newReportReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case NEW_REPORT_FILE:
      return {
        ...state,
        loading: true,
      };
    case NEW_REPORT_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
        notified: false,
      };
    case NEW_REPORT_FILE_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: payload,
        notified: false,
      };
    case NEW_REPORT_FILE_RESET:
      return {
        ...state,
        loading: false,
        data: null,
        error: null,
        notified: false,
      };
    case NEW_REPORT_FILE_NOTIFIED:
      return {
        ...state,
        notified: true,
      };
    default:
      return state;
  }
};

export default newReportReducer;
